<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible" ref="loading">     
        <div class="loading-dialog">
            <div class="loading-img"></div>
            <div class="loading-text">{{ text }}</div>
        </div>
        <div class="u-mask"></div>
    </div>
</transition>     
</template>

<script>
export default {
    data (){
        return {
            text : '嘿咻……嘿咻……',
            visible : false,
        }
    },
}
</script>

<style scoped>
.loading-dialog{
    position: relative;
    z-index: 40;
}

.loading-img{
    position: relative;
    width: 142px;
    height: 117px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/layer-ck.png);
    animation: float ease-in-out 1.5s infinite;
}

.loading-img:before{
  animation: shadow ease-in-out 1.5s infinite;
  content:'';
  display:block;
  position:relative;
  top:105%;
  height:50px;
  margin:0 200px;
  border-radius:80% 60%;
  box-shadow:0 140px 10px 10px rgba(0,0,0,.7);
  background:rgba(0,0,0,0);
  opacity: .5;
}

.loading-text{
    text-align: center;
    color: #9c9292;
}

@keyframes float {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  50% {
    -webkit-transform: translateY(10px);
    transform: translateY(10px);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}

@keyframes shadow {
  0% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: .5;
  }
  50% {
    -webkit-transform: translateY(10px) scale(.9);
    transform: translateY(10px) scale(.9);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    opacity: .5;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading/loading.vue